module.exports = __webpack_public_path__ + "img/Chinchilla.0b71c7d0.png";